import { BulkUpdateProgressBanner } from "#src/batteries-included-components/Banners/BulkUpdateProgressBanner/BulkUpdateProgressBanner";
import { ESTIMATION_METHODS_QUERY_KEY } from "#src/components/hooks/adapters/useEstimationMethods";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { useQueryClient } from "@tanstack/react-query";
import { AssetStatus } from "@validereinc/domain";
import React from "react";
import { useParams } from "react-router";

export const NetworkUpdateStatusBanner = () => {
  const { networkId } = useParams<{ networkId: string }>();
  const queryClient = useQueryClient();
  const [updateNetworkStatusJobStorageKey] = useStorageKey(
    ["async-job"],
    `update-network-status-${networkId}`
  );
  return (
    <BulkUpdateProgressBanner
      jobStorageKey={updateNetworkStatusJobStorageKey}
      invalidate={() => {
        queryClient.refetchQueries({
          predicate: (query) =>
            [
              "networks",
              "flows",
              "facilities",
              "equipment",
              "devices",
              ESTIMATION_METHODS_QUERY_KEY,
            ].some((key) => query.queryKey.includes(key)),
          type: "all",
        });
      }}
      subject={{
        singular: "asset",
        plural: "assets",
      }}
      action={(job) =>
        job?.input.status === AssetStatus.INACTIVE ? "inactivate" : "activate"
      }
    />
  );
};
